module.exports = __webpack_public_path__ + "media/images/ai_voice_samples/clara-3eee1d8261513272c1612f8354bfb2ea.mp3";